var trackEvent;

module.exports = trackEvent = function(eventName, payload) {
  var defaults, ref;
  if (payload == null) {
    payload = {};
  }
  defaults = {
    b: Cookie.get('b'),
    pageId: location.pathname
  };
  payload = _.extend({}, payload, defaults);
  if (typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null) {
    if ((ref = OptimizeSuite.TrackingHub) != null) {
      ref.add("" + eventName, payload);
    }
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy90cmFja0V2ZW50LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvdHJhY2tFdmVudC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsSUFBQTs7QUFBQSxNQUFNLENBQUMsT0FBUCxHQUFpQixVQUFBLEdBQWEsU0FBQyxTQUFELEVBQVksT0FBWjtBQUM1QixNQUFBOztJQUR3QyxVQUFVOztFQUNsRCxRQUFBLEdBQ0U7SUFBQSxDQUFBLEVBQUcsTUFBTSxDQUFDLEdBQVAsQ0FBVyxHQUFYLENBQUg7SUFDQSxNQUFBLEVBQVEsUUFBUSxDQUFDLFFBRGpCOztFQUVGLE9BQUEsR0FBVSxDQUFDLENBQUMsTUFBRixDQUFTLEVBQVQsRUFBYSxPQUFiLEVBQXNCLFFBQXRCOzs7U0FFZ0IsQ0FBRSxHQUE1QixDQUFnQyxFQUFBLEdBQUcsU0FBbkMsRUFBZ0QsT0FBaEQ7OztBQU40QiJ9
